<template>
  <component :is="currentComponent" class="legal-page content-box" />
</template>

<script>
import SetColor from '../../../lib/set-text-color'
import about from './About'
import privacy from './Policy'
import terms from './Terms'

// Converter from Word to HTML: https://wordtohtml.net/

export default {
  name: 'LegalPage',
  components: { about, privacy, terms },
  computed: {
    currentComponent () {
      return this.$route.params.page
    }
  },
  mounted () {
    SetColor()
  }
}
</script>

<style lang="scss">
  @import "../../../assets/styles/vars";
  @import "../../../assets/styles/mixins";
  .legal-page {
    padding-top: $basic-size;
    padding-bottom: $basic-size;
    @include medium-text;
    section {
      margin-bottom: $basic-padding;
    }
  }
</style>
